import { LinearProgress, makeStyles } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { SelectField, SubmitButton, TextField } from "../../components/formik";
import { types } from "../../ducks";
import { getCountries, updateProfile } from "../../ducks/actions";
import { useActionRequest } from "../../hooks";

const useStyles = makeStyles(() => ({
  fullWidth: "100%"
}));

const ProfileForm = ({ profile }) => {
  const intl = useIntl();
  const classes = useStyles();
  const validationSchema = yup.object().shape({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    title: yup.string(),
    country: yup.string().required(),
    affiliation: yup.string().required()
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);

  const {
    data: { data: countries },
    loading: countriesLoading
  } = useQuery({
    type: types.GET_COUNTRIES,
    defaultData: { data: [] }
  });

  const countryOptions = countries.map(({ id, name }) => ({
    value: id,
    label: name
  }));

  const updateProfileRequest = useActionRequest({
    action: updateProfile
  });

  const onSubmit = (profile, actions) => {
    updateProfileRequest({ profile });
    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{
        firstName: "",
        lastName: "",
        title: "",
        country: "",
        affiliation: "",
        ...profile
      }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      <Form>
        <TextField
          name="firstName"
          variant="outlined"
          fullWidth
          label={intl.formatMessage({
            id: "Profile.ProfileForm.FirstName",
            defaultMessage: "First Name"
          })}
        />
        <TextField
          name="lastName"
          variant="outlined"
          fullWidth
          label={intl.formatMessage({
            id: "Profile.ProfileForm.LastName",
            defaultMessage: "Last Name"
          })}
        />
        <TextField
          name="title"
          variant="outlined"
          fullWidth
          label={intl.formatMessage({
            id: "Profile.ProfileForm.Title",
            defaultMessage: "Title"
          })}
        />
        <TextField
          name="affiliation"
          variant="outlined"
          fullWidth
          label={intl.formatMessage({
            id: "Profile.ProfileForm.Affiliation",
            defaultMessage: "Affiliation"
          })}
        />
        {countriesLoading ? (
          <LinearProgress className={classes.fullWidth} />
        ) : (
          <SelectField
            name="country"
            variant="outlined"
            label={intl.formatMessage({
              id: "Profile.ProfileForm.Country",
              defaultMessage: "Country"
            })}
            options={countryOptions}
            elevation={8}
            fullWidth
          />
        )}
        <SubmitButton color="primary" variant="outlined" size="large">
          {intl.formatMessage({ id: "Profile.ProfileForm.Update", defaultMessage: "Update" })}
        </SubmitButton>
      </Form>
    </Formik>
  );
};

export default ProfileForm;
